import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { injectIntl, intlShape } from '../../../util/reactIntl';
import css from './SectionAllInOne.module.css';
import shape1 from '../../../assets/landing/all-in-one-shape1.png';
import shape2 from '../../../assets/landing/all-in-one-shape2.png';
import shape3 from '../../../assets/landing/all-in-one-shape3.png';
import './curves';
import './curves.css';
const isRtlLocale = locale => {
  const l = (locale || '').toLowerCase();
  return l === 'ar' || l.startsWith('ar-');
};

const SectionAllInOneComponent = props => {
  const { intl, className, rootClassName, viewport } = props;

  const isMobileLayout = viewport?.width > 0 && viewport?.width < 1024;
  const locale = intl?.locale || '';
  const rtl = isRtlLocale(locale);

  const classes = classNames(rootClassName || css.root, className);

  const titleLine1 = intl.formatMessage({ id: 'SectionAllInOne.titleLine1' });
  const titleLine2 = intl.formatMessage({ id: 'SectionAllInOne.titleLine2' });
  const subtitle = intl.formatMessage({ id: 'SectionAllInOne.subtitle' });
  const title = `${titleLine1}<br />${titleLine2}`;

  const cards = [
    {
      key: 'card1',
      title: intl.formatMessage({ id: 'SectionAllInOne.card1.title' }),
      desc: intl.formatMessage({ id: 'SectionAllInOne.card1.desc' }),
      positionClass: css.card1,
      id: 'card-ask',
    },
    {
      key: 'card2',
      title: intl.formatMessage({ id: 'SectionAllInOne.card2.title' }),
      desc: intl.formatMessage({ id: 'SectionAllInOne.card2.desc' }),
      positionClass: css.card2,
      id: 'card-build',
    },
    {
      key: 'card3',
      title: intl.formatMessage({ id: 'SectionAllInOne.card3.title' }),
      desc: intl.formatMessage({ id: 'SectionAllInOne.card3.desc' }),
      positionClass: css.card3,
      id: 'card-see',
    },
    {
      key: 'card4',
      title: intl.formatMessage({ id: 'SectionAllInOne.card4.title' }),
      desc: intl.formatMessage({ id: 'SectionAllInOne.card4.desc' }),
      positionClass: css.card4,
      id: 'card-understand',
    },
    {
      key: 'card5',
      title: intl.formatMessage({ id: 'SectionAllInOne.card5.title' }),
      desc: intl.formatMessage({ id: 'SectionAllInOne.card5.desc' }),
      positionClass: css.card5,
      id: 'card-take',
    },
  ];

  return (
    <section className={classes} dir={rtl ? 'rtl' : 'ltr'}>
      <span className={css.shape1}>
        <img src={shape1} alt="" />
      </span>
      <span className={css.shape2}>
        <img src={shape2} alt="" />
      </span>
      <span className={css.shape3}>
        <img src={shape3} alt="" />
      </span>
      <div className={css.content}>
        <header className={css.header}>
          <h2 className={css.title} dangerouslySetInnerHTML={{ __html: title }} />
          {/* <p className={css.subtitle}>{subtitle}</p> */}
        </header>
        {/* <div className={css.stage}>
          {cards.map((c, index) => (
            <article key={c.key} id={c.id} className={classNames(css.card, c.positionClass)}>
              <h3 className={css.cardTitle}>{c.title}</h3>
              <p className={css.cardDesc}>{c.desc}</p>
              <div className={css.curveImg}>
                <img src={c.curveImg} alt={c.title} />
              </div>
            </article>
          ))}
        </div> */}

        {cards && cards.length === 5 && (
          <div className="container" id="container">
            <div className="decorationsLayer" aria-hidden="true">
              <svg className="arrows" id="arrowSvg"></svg>
            </div>

            <div className="contentLayer">
              <div className="row row-top">
                <div className="card" id="card-ask">
                  <div className="card-title">{cards[0].title}</div>
                  <div className="card-body">{cards[0].desc}</div>
                </div>

                <div className="card" id="card-build">
                  <div className="card-title">{cards[1].title}</div>
                  <div className="card-body">{cards[1].desc}</div>
                </div>
              </div>

              <div className="row row-center">
                <div className="card" id="card-see">
                  <div className="card-title">{cards[2].title}</div>
                  <div className="card-body">{cards[2].desc}</div>
                </div>
              </div>

              <div className="row row-bottom">
                <div className="card" id="card-understand">
                  <div className="card-title">{cards[3].title}</div>
                  <div className="card-body">{cards[3].desc}</div>
                </div>

                <div className="card" id="card-take">
                  <div className="card-title">{cards[4].title}</div>
                  <div className="card-body">{cards[4].desc}</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {isMobileLayout ? null : (
        <div className={css.waveImg}>
          <svg
            width="1440"
            height="749"
            viewBox="0 0 1440 749"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
          >
            <path
              d="M1213.08 100.626C1135.52 65.4013 930.013 -23.9613 626.389 6.06825C411.149 27.3273 198.25 109.524 73.1759 227.845C21.7813 276.495 -14.6588 330.234 -37.3278 384.929C-74.3093 474.394 -73.0363 570.163 -5.63852 643.969C61.7705 717.815 203.714 764.22 347.613 742.932C452.669 727.408 548.923 679.222 654.489 673.245C777.224 666.319 877.608 717.904 997.451 725.055C1131.02 732.998 1270.13 684.175 1376.53 622.453C1413.43 601.032 1448.39 577.423 1471.41 549.902C1514.57 498.393 1515.27 452.439 1515.15 430.602C1514.75 341 1425.31 196.993 1213.08 100.626Z"
              fill="#FDF4EC"
            />
          </svg>
        </div>
      )}
    </section>
  );
};

SectionAllInOneComponent.defaultProps = {
  className: null,
  rootClassName: null,
};

SectionAllInOneComponent.propTypes = {
  intl: intlShape.isRequired,
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default injectIntl(SectionAllInOneComponent);
